import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {styled} from "@mui/material/styles"

import {InvalidCodeImage} from "@indebted/assets"
import {Page} from "@indebted/components/Page"

function OptOutFailurePage({I18n}) {
	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{I18n.Title}
				</Typography>
			</Grid>

			<GridImage>
				<InvalidCodeImage />
			</GridImage>
		</Page>
	)
}

const GridImage = styled(Grid)`
	margin: ${(props) => props.theme.spacing(5)};
`

export {OptOutFailurePage}
